import React, {Fragment} from 'react';

export default function EmptyComponent() {
    return (<Fragment/>);
}